"use client";
import styles from "./FiltersSection.module.css";
import { useState, useEffect } from "react";
import { CircularProgress, IconButton, TextField, Button } from "@mui/material";
import RefreshIcon from "@material-ui/icons/Refresh";
const FiltersSection = ({
  filters,
  onFiltersChange,
  showSelectAll,
  selectedCount,
  totalPending,
  onSelectAll,
  onBulkApprove,
  branchOptions = ["Branch"],
  professionOptions,
  handleDownloadData,
  loadingExport,
  handleResetFilters,
  searchInput,
  setSearchInput,
}) => {
  const handleInputChange = (field, value) => {
    // console.log("valueData", value);
    onFiltersChange({
      ...filters,
      [field]: value,
    });
  };

  // ✅ handle search button click
  const handleSearch = () => {
    const trimmedValue =
      searchInput && searchInput.trim() !== "" ? searchInput.trim() : "Search";

    onFiltersChange({
      ...filters,
      searchKey: trimmedValue,
    });
  };

  const handleAutoCheckout = () => {
    onFiltersChange({
      ...filters,
      autoCheckoutOnly: filters.autoCheckoutOnly,
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.filtersRow}>
        {/* Branch Filter */}
        <select
          value={filters.branch || ""}
          onChange={(e) => handleInputChange("branch", e.target.value)}
          className={styles.filterSelect}
        >
          <option value="">All Branches</option>
          {branchOptions.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>

        {/* Status Filter */}
        <select
          value={filters.status || ""}
          onChange={(e) => handleInputChange("status", e.target.value)}
          className={styles.filterSelect}
        >
          <option value="">All Status</option>
          <option value="Pending">Pending Approval</option>
          <option value="Approved">Approved</option>
          <option value="Disputed">Disputed</option>
        </select>

        {/* Auto Check-Out Filter */}
        {/* <select
          value={filters.autoCheckOut || ""}
          onChange={(e) => handleInputChange("autoCheckOut", e.target.value)}
          className={styles.filterSelect}
        >
          { <option value="">All Auto Check-Out</option> }
          {<option value="Yes">Auto Check-Out</option> }
        </select> */}

        {/* Profession Filter */}
        <select
          value={filters.profession || ""}
          onChange={(e) => handleInputChange("profession", e.target.value)}
          className={styles.filterSelect}
        >
          <option value="">All Profession</option>
          {professionOptions.map((option, index) => (
            <option key={index} value={option.value}>
              {option.value}
            </option>
          ))}
        </select>

        {/* Date Filters */}
        <TextField
          label="Start Date"
          type="date"
          value={filters.startDate || ""}
          onChange={(e) => handleInputChange("startDate", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          className={styles.dateField}
        />
        <TextField
          label="End Date"
          type="date"
          value={filters.endDate || ""}
          onChange={(e) => handleInputChange("endDate", e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          className={styles.dateField}
        />

        {/* reset all filter */}
        <IconButton
          onClick={handleResetFilters}
          color="primary"
          className={styles.dateField}
        >
          <RefreshIcon style={{ fontSize: 30 }} />
        </IconButton>

        {/* Export  */}
        <Button
          onClick={handleDownloadData}
          variant="contained"
          color="primary"
          disabled={loadingExport}
          className={styles.dateField}
        >
          {/* {"Export"} */}
          {loadingExport ? "Loading..." : "Export"}
        </Button>

        {/* 🔍 Search Field */}
        <TextField
          // label="Search"
          placeholder="Search by Prof Name, Job ID, Hospital Name"
          variant="outlined"
          size="small"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyPress={handleKeyPress}
          className={styles.dateField}
          style={{ minWidth: "260px" }}
        />

        {/* Search Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          className={styles.dateField}
        >
          Search
        </Button>

        {/* Auto Check-Out Only */}
        <label className={styles.autoOnlyLabel}>
          <input
            type="checkbox"
            checked={!!filters.autoCheckoutOnly}
            onChange={(e) =>
              handleInputChange("autoCheckoutOnly", e.target.checked)
            }
            className={styles.autoOnlyCheckbox}
          />
          Auto Check-Out Only
        </label>

        {/* Auto Check-In Only */}
        <label className={styles.autoOnlyLabel}>
          <input
            type="checkbox"
            checked={!!filters.autoCheckinOnly}
            onChange={(e) =>
              handleInputChange("autoCheckinOnly", e.target.checked)
            }
            className={styles.autoOnlyCheckbox}
          />
          Auto Check-In Only
        </label>
        {/* <Button
          onClick={handleSearch}
          variant="contained"
          color="secondary"
          // startIcon={<SearchIcon />}
          className={styles.dateField}
        >
          Search
        </Button> */}
      </div>

      {showSelectAll && filters.branch.toLowerCase() !== "branch" && (
        <div className={styles.selectAllContainer}>
          <label className={styles.selectAllLabel}>
            <input
              type="checkbox"
              checked={selectedCount === totalPending && totalPending > 0}
              onChange={(e) => onSelectAll(e.target.checked)}
            />
            <span>Select All ({totalPending} pending shift(s))</span>
          </label>
          {selectedCount > 0 && (
            <div className={styles.bulkActions}>
              <span className={styles.selectedInfo}>
                {selectedCount} shift{selectedCount !== 1 ? "s" : ""} selected
              </span>
              <button className={styles.bulkApproveBtn} onClick={onBulkApprove}>
                Approve Selected
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FiltersSection;
